import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KBreadcrumb";
var classes = {
    item: "".concat(PREFIX, "-item"),
    lastItem: "".concat(PREFIX, "-lastItem"),
    lastItemWithoutClik: "".concat(PREFIX, "-lastItemWithoutClik"),
    link: "".concat(PREFIX, "-link"),
    itemTypo: "".concat(PREFIX, "-itemTypo"),
    home: "".concat(PREFIX, "-home"),
    homeIcon: "".concat(PREFIX, "-homeIcon"),
    lastItemTypo: "".concat(PREFIX, "-lastItemTypo"),
    linkTypo: "".concat(PREFIX, "-linkTypo"),
    button: "".concat(PREFIX, "-button"),
    buttonName: "".concat(PREFIX, "-buttonName")
};
var StyledKBreadcrumb = styled(Box)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {
            display: "flex",
            alignItems: "center"
        },
        _b[theme.breakpoints.down("sm")] = {
            display: "block",
            width: "100%"
        },
        _b["& .".concat(classes.item)] = {
            textDecoration: "underline"
        },
        _b["& .".concat(classes.lastItem)] = {
            textDecoration: "none"
        },
        _b["& .".concat(classes.lastItemWithoutClik)] = {
            textDecoration: "none",
            cursor: "default",
            "&:hover": {
                textDecoration: "none"
            }
        },
        _b["& .".concat(classes.link)] = {
            cursor: "pointer"
        },
        _b["& .".concat(classes.itemTypo)] = {},
        _b["& .".concat(classes.home)] = {
            cursor: "pointer"
        },
        _b["& .".concat(classes.homeIcon)] = {
            verticalAlign: "text-top"
        },
        _b["& .".concat(classes.lastItemTypo)] = {
            color: theme.palette.text.primary,
            fontWeight: "bold"
        },
        _b["& .".concat(classes.linkTypo)] = {
            color: theme.palette.primary.main
        },
        _b["& .".concat(classes.button)] = (_c = {
                marginLeft: theme.spacing(2)
            },
            _c[theme.breakpoints.down("sm")] = {
                margin: theme.spacing(1, 0),
                width: "100%"
            },
            _c),
        _b["& .".concat(classes.buttonName)] = (_d = {
                display: "none",
                marginLeft: theme.spacing(1)
            },
            _d[theme.breakpoints.down("sm")] = {
                display: "inline-block"
            },
            _d),
        _b);
});

export { classes, StyledKBreadcrumb as default };
//# sourceMappingURL=index.styled.js.map
